import React from "react";
import ReactDOM from "react-dom";
import { PortalApp } from "./PortalApp";
import { AppProvider } from "./providers/AppProvider";
import { SB1ErrorBoundary } from "@sb1finans/components/dist/Sb1ErrorBoundary"
import { createLogger, AppInsightsLogger, LogLevel, LoggerProvider } from "@sb1finans/components/dist/SB1Logger"

const logger = createLogger({
      interceptors: [
          AppInsightsLogger({instrumentationKey: 'e2a8fa89-f6f6-4058-bd27-0a0714ade024'})
      ],
      captureConsole: true,
      logLevel: LogLevel.INFO
  })

fetch("/config/config.json").then(response => response.json()).then(json => {
      console.log(json)
      return json
}).then((config) => {
      console.info("Initializing app portal with config: ", config)
      ReactDOM.render(
            <React.StrictMode>
                  <SB1ErrorBoundary> {/* Add error logging */}
                        <AppProvider config={config}>
                              <PortalApp />
                        </AppProvider>
                  </SB1ErrorBoundary>
            </React.StrictMode>,
            document.getElementById('root')
        );
      console.info("App initialized.")
})